import { Pagination } from '@/Domain/Procedures/RepositoryModifiers/Pagination'
import {
  ProcedureNotFoundError,
  ProcedureRepositoryError
} from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'
import { ApiClient, Api500Error, Api404Error, Api403Error } from '@/Domain/ApiClient'
import { UserExpedienteRepository } from '@/Domain/Expediente/UserExpedienteRepository'
import { ExpedienteFilters, Expediente, ReferenciaExpediente, ExpedienteFactory } from '@/Domain/Expediente'
import { AxiosUserExpedienteData } from './AxiosUserExpedienteData'

// TODO - Conectar con BackEnd
export class AxiosUserExpedienteRepository implements UserExpedienteRepository {
  private _apiClient: ApiClient
  private _factory: ExpedienteFactory<AxiosUserExpedienteData>

  constructor (apiClient: ApiClient, factory: ExpedienteFactory<AxiosUserExpedienteData>) {
    this._apiClient = apiClient
    this._factory = factory
  }

  async byUser (
    accountId: AccountId,
    pagination: Pagination,
    filters: ExpedienteFilters
  ): Promise<Expediente[]> {
    const data = {
      page: pagination.page,
      itemsPerPage: pagination.itemsPerPage,
      ...filters
    }
    const url = '/sobree/api/batches/show/' + accountId.accountId()
    try {
      const response = await this._apiClient.makeGetRequest(url, data)
      const expedientes: Expediente[] = response.data.data.map((current: AxiosUserExpedienteData) => {
        return this._factory.makeExpediente(current)
      })
      return Promise.resolve(expedientes)
    } catch (error) {
      return Promise.reject(this.transformError(error))
    }
  }

  async totalItemsByUserCount (accountId: AccountId, filters: ExpedienteFilters): Promise<number> {
    const data = { ...filters }
    const url = '/sobree/api/batches/show/' + accountId.accountId() + '/count'
    try {
      const response = await this._apiClient.makeGetRequest(url, data)
      return parseInt(response.data.data.data.total, 10)
    } catch (error) {
      return Promise.reject(this.transformError(error))
    }
  }

  async byNumReferencia (numExpediente: ReferenciaExpediente): Promise<Expediente> {
    const url = '/sobree/api/batches/details/' + numExpediente.referencia
    try {
      const response = await this._apiClient.makeGetRequest(url, {})
      const expediente = this._factory.makeExpediente(response.data.data)
      return Promise.resolve(expediente)
    } catch (error) {
      return Promise.reject(this.transformError(error))
    }
  }

  private transformError (error: Error): Error {
    if (error instanceof Api500Error) {
      return new ProcedureRepositoryError('Server unavailable: ' + error.message)
    }
    if (error instanceof Api404Error) {
      return new ProcedureNotFoundError('Procedure not found: ' + error.message)
    }
    if (error instanceof Api403Error) {
      return new ProcedureNotFoundError('Procedure not found: ' + error.message)
    }

    return error
  }
}
